/* angular:styles/component:css;ee67b3e97dcca52665bbdbdf0d5bd48492e8496712c0e40dd855edf3f0e5bd46;/app/src/app/shared/animations/currency-field.component.ts */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-transform: uppercase;
}
.search-box-wrapper {
  position: absolute;
  max-height: 259px;
  height: fit-content;
  width: 257px;
}
.additional-charges-form {
  width: 140px;
  height: 36px;
  border-radius: 8px;
  padding-inline-start: 65px;
}
.additional-charges-form-2 {
  width: 180px;
  height: 36px;
  border-radius: 8px;
  padding-inline-start: 85px;
}
.additional-charges-div {
  position: relative;
  width: 140px;
}
.additional-charges-div-2 {
  position: relative;
  width: 180px;
}
.additional-charges-img {
  position: absolute;
  left: 52px;
  top: 8px;
}
.additional-charges-img-2 {
  position: absolute;
  left: 72px;
  top: 8px;
}
.additional-charges-currency-label {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 52px;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 12px;
  padding-left: 12px;
  font-family: "Lato-Regular";
  font-size: 13px;
  font-weight: lighter;
  cursor: pointer;
  outline: none;
}
.additional-charges-currency-label-2 {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 52px;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 12px;
  padding-left: 12px;
  font-family: "Lato-Regular";
  font-size: 13px;
  font-weight: lighter;
  outline: none;
}
.code-container {
  cursor: pointer;
  text-transform: uppercase;
}
.code-changeable-img {
  position: absolute;
  left: 48px;
  top: 12px;
}
.spacer {
  padding-bottom: 4px;
}
/*# sourceMappingURL=currency-field.component.css.map */
